<template>
  <v-dialog v-model="show" max-width="624">
    <v-card>
      <v-card-title class="body-1">
        {{
          userData.Id > 0
            ? $vuetify.lang.t('$vuetify.EDIT_USER_SLASH_COMPANY')
            : $vuetify.lang.t('$vuetify.ADD_USER_SLASH_COMPANY')
        }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="formValid">
          <v-container>
            <v-row class="d-flex align-center">
              <v-col v-if="isGlobalAdmin" cols="12">
                <v-select
                  v-model="userData.Apps"
                  :items="availableApplications"
                  item-text="Name"
                  return-object
                  label="App"
                  outlined
                  hide-details
                  multiple
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="userData.Name"
                  :label="$vuetify.lang.t('$vuetify.REGISTER.NAME')"
                  hide-details
                  outlined
                  required
                  :rules="nameRules"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="userData.Email"
                  :label="$vuetify.lang.t('$vuetify.REGISTER.EMAIL')"
                  hide-details
                  outlined
                  required
                  :rules="emailRules"
                  type="email"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <!-- <v-text-field
                  v-model="userData.PhoneNumber"
                  :label="$vuetify.lang.t('$vuetify.REGISTER.PHONE_NUMBER')"
                  hide-details
                  outlined
                ></v-text-field> -->
                <phone-select
                  :initial-country-code="
                    userData.Region && userData.Region !== ''
                      ? userData.Region
                      : owner.Region
                  "
                  :initial-phone-number="userData.PhoneNumber"
                />
              </v-col>
              <v-col v-if="isGlobalAdmin" cols="12">
                <v-menu offset-y dense>
                  <template v-slot:activator="{ on }">
                    <v-btn color="secondary" v-on="on">
                      {{ selectedPrivileges.title }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="item in privileges"
                      :key="item.id"
                      dense
                      @click="
                        ;(userData.Region = ''),
                          (userData.Zones = ''),
                          (selectedPrivileges = item)
                      "
                    >
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col
                v-if="isGlobalAdmin && selectedPrivileges.id === 2"
                cols="12"
                sm="3"
              >
                <v-select
                  v-model="userData.Region"
                  :items="userRegions"
                  :label="$vuetify.lang.t('$vuetify.EDIT_WHITELISTS.REGION')"
                  outlined
                  hide-details
                  :loading="loading.state && loading.type === 'getUserRegions'"
                  clearable
                  @change="setUserZones([])"
                ></v-select>
              </v-col>
              <v-col
                v-if="isGlobalAdmin && selectedPrivileges.id === 2"
                cols="12"
                sm="9"
              >
                <v-select
                  :value="zonesToArray(userData.Zones)"
                  :items="userZones"
                  multiple
                  hide-details
                  :menu-props="{
                    bottom: true,
                    offsetY: true
                  }"
                  clearable
                  outlined
                  label="Select zone(s)"
                  :loading="loading.state && loading.type === 'getUserZones'"
                  class="px-0"
                  @focus="getUserZones({ region: userData.Region })"
                  @change="setZonesAsString($event)"
                  @click:clear="userData.Zones = ''"
                >
                </v-select>
              </v-col>
              <v-col v-if="isGlobalAdmin" cols="12">
                <v-text-field
                  v-model="userData.Comments"
                  :label="$vuetify.lang.t('$vuetify.DESCRIPTION')"
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
              <v-col v-if="!userData.Id || userData.Id <= 0" cols="12">
                <v-checkbox
                  v-model="autoGeneratePassword"
                  :label="$vuetify.lang.t('$vuetify.AUTO_GENERATE_PASSWORD')"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col v-if="!autoGeneratePassword" cols="12" class="py-0">
                <p>
                  {{ $vuetify.lang.t('$vuetify.PASSWORD_CRITERIA_MISMATCH') }}
                </p>
              </v-col>
              <v-col
                v-if="
                  (!userData.Id || userData.Id <= 0) && !autoGeneratePassword
                "
                cols="6"
              >
                <v-text-field
                  v-model="userData.Password"
                  :label="$vuetify.lang.t('$vuetify.REGISTER.PASSWORD')"
                  hide-details
                  :required="!userData.Id || userData.Id <= 0"
                  outlined
                  :rules="[passwordRules]"
                  type="password"
                ></v-text-field>
              </v-col>
              <v-col
                v-if="
                  (!userData.Id || userData.Id <= 0) && !autoGeneratePassword
                "
                cols="6"
              >
                <v-text-field
                  v-model="confirmPassword"
                  :label="$vuetify.lang.t('$vuetify.REGISTER.PASSWORD_AGAIN')"
                  hide-details
                  :required="!userData.Id || userData.Id <= 0"
                  outlined
                  type="password"
                ></v-text-field>
              </v-col>
              <v-col v-if="userData.Id > 0" cols="6">
                <v-checkbox
                  v-model="userData.Verified"
                  :label="$vuetify.lang.t('$vuetify.ACCESS_TO_PLATFORM')"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col v-if="userData.Id > 0 && isGlobalAdmin" cols="6">
                <v-checkbox
                  v-model="userData.EnforcementAppEnabled"
                  :label="$vuetify.lang.t('$vuetify.ENFORCEMENT_APP_ENABLED')"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col v-if="userData.Id > 0 && isGlobalAdmin" cols="6">
                <v-checkbox
                  v-model="userData.CanViewParkingFines"
                  :label="$vuetify.lang.t('$vuetify.CAN_VEW_PARKING_FINES')"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col v-if="!userData.Id || userData.Id <= 0" cols="6">
                <v-checkbox
                  v-model="userData.IsNewRenter"
                  :label="$vuetify.lang.t('$vuetify.IS_NEW_TENANT')"
                ></v-checkbox>
              </v-col>
              <v-col
                v-if="(userData.Id || userData.Id > 0)"
                cols="12"
              >
                Created by
                <span class="font-weight-bold">
                  {{ userData.CreatedBy || 'Unknown' }}
                </span>
                at
                <span class="font-weight-bold">
                  {{ new Date(userData.CreatedAt).toLocaleString() }}
                </span>
                <br />
                Last login:
                <span class="font-weight-bold">
                  {{ new Date(userData.LastLoginTime).toLocaleString() }}
                </span>
              </v-col>
            </v-row>
            <v-row class="d-flex align-center">
              <v-col cols="12">
                {{ $vuetify.lang.t('$vuetify.LOCATIONS') }}
                <span class="font-weight-bold">
                  {{ getUserPlaces() }}
                </span>
                <br />
                {{ $vuetify.lang.t('$vuetify.WHITELISTS.TITLE') }}
                <span class="font-weight-bold">
                  {{ getUserWhitelists() }}
                </span>
                <br />
                {{ $vuetify.lang.t('$vuetify.FLEETS.TITLE') }}
                <span class="font-weight-bold">
                  {{ getUserFleets() }}
                </span>
                <br />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="secondary--text" :disabled="!formValid" @click="updateUser()">
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Owner from '@/models/owner'
import { EventBus } from '@/event-bus.js'

export default {
  name: 'EditOwnerDialog',
  components: {
    PhoneSelect: () =>
      import(
        /* webpackChunkName: "PhoneSelect" */ '@/components/commonComponents/PhoneSelect'
      )
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    owner: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: 'Add owner'
    }
  },
  data() {
    return {
      formValid: true,
      userData: { ...this.owner },
      privileges: [
        { id: 1, title: 'Superadmin' },
        { id: 2, title: 'Region/Zone admin' },
        { id: 3, title: 'None' }
      ],
      selectedPrivileges: null,
      confirmPassword: '',
      diallingCode: '',
      isValidPhoneNumber: false,
      nameRules: [
        v =>
          v.length >= 2 ||
          this.$vuetify.lang.t('$vuetify.registerForm.nameIsRequired')
      ],
      autoGeneratePassword: true
    }
  },
  computed: {
    ...mapGetters('app', ['loading', 'availableApplications']),
    ...mapGetters('authentication', ['user', 'isGlobalAdmin']),
    ...mapGetters('users', ['userRegions', 'userZones']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.userData = new Owner().getObject()
          this.$emit('close')
        }
      }
    },
    passwordRules() {
      if (
        !this.userData.Id ||
        (this.userData.Id <= 0 && !this.autoGeneratePassword)
      ) {
        return v =>
          this.isStrongAndValidPassword(v) ||
          'Password must contain at least 8 characters, 1 number and 1 capital letter'
      }
      return true
    },
    isValidEmail() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(this.userData.Email).toLowerCase())
    },
    emailRules() {
      return [
        v => !!v || 'Email is required',
        () => this.isValidEmail || 'Email must be valid'
      ]
    }
  },
  created() {
    this.getUserRegions()
    this.getUserZones({ region: this.userData.Region })
    this.getAvailableApplications()
    if (this.userData.Admin) {
      if (this.userData.Region !== '' || this.userData.Zones !== '') {
        this.selectedPrivileges = { id: 2, title: 'Region/Zone admin' }
      } else {
        this.selectedPrivileges = { id: 1, title: 'Superadmin' }
      }
    } else {
      this.selectedPrivileges = { id: 3, title: 'None' }
    }
    EventBus.$on('phoneNumberChanged', item => {
      this.userData.PhoneNumber = item.event
      this.isValidPhoneNumber = item.valid
    })
    EventBus.$on('phoneDiallingCodeChanged', item => {
      this.diallingCode = item.event.dialling_code
      this.isValidPhoneNumber = item.valid
    })
  },
  methods: {
    ...mapActions('app', ['getAvailableApplications', 'error']),
    ...mapActions('users', ['postUser', 'getUserRegions', 'getUserZones']),
    ...mapMutations('users', ['setUserZones']),
    isStrongAndValidPassword(password) {
      // Check if password is at least 8 characters long
      if (password.length < 8) {
        return false
      }

      // Has at least one number
      if (!/\d/.test(password)) {
        return false
      }

      // Has at least one capital letter
      if (!/[A-Z]/.test(password)) {
        return false
      }

      return true
    },
    updateUser() {
      if (!this.userData.Email) {
        return this.errorAlert('Email is required')
      }
      if (this.userData.PhoneNumber.length && !this.isValidPhoneNumber) {
        return this.errorAlert('Invalid phone number')
      }
      if (
        this.selectedPrivileges.id === 2 &&
        !this.userData.Region &&
        !this.userData.Zones
      ) {
        return this.errorAlert(
          'Region/Zone admin cannot have empty region and zone'
        )
      }
      if (
        this.userData.Password &&
        this.userData.Password !== this.confirmPassword
      ) {
        return this.errorAlert('Passwords must match')
      }
      if (
        this.userData.Password &&
        this.userData.Password !== '' &&
        !this.autoGeneratePassword &&
        !this.isStrongAndValidPassword(this.userData.Password)
      ) {
        return this.errorAlert(
          'Password must contain at least 8 characters, 1 number and 1 capital letter'
        )
      }
      this.userData.Admin = this.selectedPrivileges.id === 1
      return this.postUser(this.userData).then(() => {
        if (!this.error) {
          this.show = false
        }
      })
    },
    getAppNameByAppId(id) {
      const appInAvailableApplications = this.availableApplications.find(
        app => {
          return app.ID === id
        }
      )
      return appInAvailableApplications
        ? appInAvailableApplications.ShortName
        : 'None'
    },
    zonesToArray(zones) {
      if (zones.length) {
        return zones.slice(1, -1).split('|')
      }
      return []
    },
    setZonesAsString(value) {
      if (Array.isArray(value) && value.length > 0) {
        this.userData.Zones = `|${value.join('|')}|`
      }
    },
    errorAlert(message) {
      this.$store.commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message
        },
        { root: true }
      )
    },
    getUserPlaces() {
      if (!this.owner.Places) {
        return '-'
      }
      const combinedString = this.owner.Places.map(
        place =>
          `(${place.Id} - ${place.Name}, ${place.AddressText} ${
            place.WithAdminRights ? '✎' : '웃'
          })`
      ).join(', ')
      return combinedString
    },
    getUserFleets() {
      if (!this.owner.Fleets) {
        return '-'
      }
      const combinedString = this.owner.Fleets.map(
        fleet =>
          `(ID: ${fleet.Id} - ${fleet.Name} ${fleet.CanEditUsers ? '✎' : '웃'})`
      ).join(', ')
      return combinedString
    },
    getUserWhitelists() {
      if (!this.owner.Whitelists) {
        return '-'
      }
      const combinedString = this.owner.Whitelists.map(
        whitelist =>
          `(ID: ${whitelist.Id} - ${whitelist.Name} ${
            whitelist.CanEditUsers ? '✎' : '웃'
          })`
      ).join(', ')
      return combinedString
    }
  }
}
</script>
